import ToastificationContent from '@core/components/toastification/ToastificationContent'
import toast from '@/libs/toastification'

export const errorHandler = err => {
  const error = err.response ? err.response.data.error : err
  if (error.isAxiosError) {
    if (error.message === 'Network Error') {
      toast({
        component: ToastificationContent,
        props: {
          title: 'Connection',
          icon: 'BellIcon',
          text: 'Please check your internet connection',
          variant: 'danger',
        },
      }, { toastClassName: 'error-toast' })
      return
    }
  }
  if (error.code === 'error.CompetitionNotOpen') {
    toast({
      component: ToastificationContent,
      props: {
        title: 'Error',
        icon: 'AlertTriangleIcon',
        text: 'Refund not allowed',
        variant: 'danger',
      },
    }, { toastClassName: 'error-toast' })
    return
  }
  if (error.code === 'error.invalidBonusCreditConfig') {
    toast({
      component: ToastificationContent,
      props: {
        title: 'Error',
        icon: 'AlertTriangleIcon',
        text: 'Invalid Advanced Rebate Bucket config: Credit limit must be ≥ Max per draw ≥ Min per draw > 0',
        variant: 'danger',
      },
    }, { toastClassName: 'error-toast' })
    return
  }
  if (error.code === 'error.WithdrawalTwoFactorPhoneRequired') {
    toast({
      component: ToastificationContent,
      props: {
        title: 'Error',
        icon: 'AlertTriangleIcon',
        text: 'User has no phone number. Add a phone number (international format, e.g. +61...) before enabling withdrawal 2FA',
        variant: 'danger',
      },
    }, { toastClassName: 'error-toast' })
    return
  }
  toast({
    component: ToastificationContent,
    props: {
      title: 'Error',
      icon: 'AlertTriangleIcon',
      text: error.message || error,
      variant: 'danger',
    },
  }, { toastClassName: 'error-toast' })
}

export default function useToastHandler() {
  const showToastError = (err, title) => {
    toast({
      component: ToastificationContent,
      props: {
        title: title || 'Error',
        icon: 'AlertTriangleIcon',
        text: err ? err.message || err : null,
        variant: 'danger',
      },
    }, { toastClassName: 'error-toast' })
  }

  const showToastSuccess = (title, text) => {
    toast({
      component: ToastificationContent,
      props: {
        title,
        text,
        icon: 'CheckIcon',
        variant: 'success',
      },
    })
  }

  return {
    errorHandler,
    showToastError,
    showToastSuccess,
  }
}
